import React, { FC } from 'react'
import { Page as PageType } from '@mortgage-pos/types'
import { useVariation } from '@mortgage-pos/ui/services/featureFlags'
import { FEATURE_FLAG_TYPES } from '@mortgage-pos/data'
import Button from '@mortgage-pos/ui/components/Button'
import { useStoreState, useStoreActions } from '@mortgage-pos/ui/store'
import { redirectTo } from '@mortgage-pos/utils'

type Props = {
  page: PageType
  answer: Function
  answers: object
}

export const Stop: FC<Props> = ({ page }) => {
  const { mergedAnswers } = useStoreState((state) => state.answers)
  const { elementClicked } = useStoreActions((store) => store.tracking)

  const bankrateCompareEnabled = useVariation(
    FEATURE_FLAG_TYPES.BANKRATE_COMPARE_ENABLED
  )

  const handleSeeRatesClick = (e: React.SyntheticEvent) => {
    e.preventDefault()

    elementClicked({
      elementType: 'Button',
      location: `State Stop page`,
      actionOutcome: `Routes user to Bankrate rates page`,
      text: 'See rates in my area',
    })

    const bankrateBaseUrl =
      'https://www.bankrate.com/mortgages/mortgage-rates/?partnerId=br3&pid=br3&pointsChanged=false&searchChanged=false&disablePre=1&'
    const bankrateUrlParams = new URLSearchParams()

    bankrateUrlParams.append('zipCode', mergedAnswers.zipCode)
    return redirectTo(bankrateBaseUrl + bankrateUrlParams.toString())
  }

  return (
    <div className="page --mg-bottom">
      {page.title && <h2 className="page__title">{page.title}</h2>}

      {page.description && (
        <p className="page__description">{page.description}</p>
      )}

      {page.subTitle && <h4 className="page__subtitle">{page.subTitle}</h4>}
      {bankrateCompareEnabled ? (
        <Button
          className="file-upload__button --margin-top"
          content="See rates in my area"
          onClick={handleSeeRatesClick}
        />
      ) : null}
    </div>
  )
}
